import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-jobs',
  templateUrl: './page-jobs.component.html',
  styleUrls: ['./page-jobs.component.css']
})
export class PageJobsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
